import { render, staticRenderFns } from "./BulkDeleteButton.vue?vue&type=template&id=2158b5be&"
import script from "./BulkDeleteButton.vue?vue&type=script&lang=ts&"
export * from "./BulkDeleteButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports